import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import gethBg from '../../../static/geth-bg.png';
import {
  Hero,
  SectionTitle,
  ValidatorClientPageStyles,
} from '../ValidatorClientComponents';
import { PageTemplate } from '../../../components/PageTemplate';
import { Text } from '../../../components/Text';
import { Link } from '../../../components/Link';
// import { Code } from '../../../components/Code';
import { Heading } from '../../../components/Heading';
// import { ClientDiversityWarning } from '../../../components/ClientDiversityWarning';

import { IS_MAINNET } from '../../../utils/envVars';

// eslint-disable-next-line no-unused-vars
export const GethDetails = () => (
  <>
    {/* <ClientDiversityWarning>
      <FormattedMessage defaultMessage="Currently Geth is used by >66% of the network." />
    </ClientDiversityWarning> */}
    <SectionTitle level={2} className="mb5">
      Geth
    </SectionTitle>
    <Text className="mt10">
      <FormattedMessage defaultMessage="One of the three original implementations of the Ethereum protocol (Which is used by the LUKSO Blockchain)." />
    </Text>
    <SectionTitle level={2} className="mb5">
      <FormattedMessage defaultMessage="Language information" />
    </SectionTitle>
    <Text className="mt10">
      <FormattedMessage defaultMessage="Geth is written in Go, fully open source and licensed under the GNU LGPL v3." />
    </Text>
    <section>
      <SectionTitle level={2} className="mb5">
        <FormattedMessage defaultMessage="Installation" />
      </SectionTitle>
      <Text>
        <FormattedMessage defaultMessage="The Geth documentation explains how to download and install the client." />
      </Text>
      <Link
        primary
        to="https://geth.ethereum.org/docs/install-and-build/installing-geth"
        className="mt10"
      >
        <FormattedMessage defaultMessage="Geth installation documentation" />
      </Link>
    </section>
    <section>
      <SectionTitle level={2} className="mb5">
        <FormattedMessage defaultMessage="Setup" />
      </SectionTitle>
      <Text className="mb20 mt10">
        <FormattedMessage defaultMessage="We recommend to use the LUKSO CLI to run your client, if you are less experienced. Otherwise you can use the network config files directly to connect to LUKSO." />
      </Text>
      <Link primary to="https://github.com/lukso-network/tools-lukso-cli">
        <FormattedMessage defaultMessage="LUKSO Command Line Interface (CLI)" />
      </Link>
      <Link primary to="https://github.com/lukso-network/network-configs">
        <FormattedMessage defaultMessage="LUKSO Network Configs" />
      </Link>
      {!IS_MAINNET && (
        <>
          <Heading level={3} className="mt20">
            <FormattedMessage defaultMessage="Testing on Testnet" />
          </Heading>
          <Text className="mt10">
            <FormattedMessage defaultMessage="Use the LUKSO CLI or the testnet configs the to sync the Testnet." />
          </Text>
          <Link
            primary
            to="https://github.com/lukso-network/tools-lukso-cli#how-to-start-a-node"
          >
            <FormattedMessage defaultMessage="LUKSO CLI start documentation" />
          </Link>
        </>
      )}
    </section>
  </>
);

export const Geth = () => {
  const { formatMessage } = useIntl();
  return (
    <PageTemplate
      title={formatMessage(
        { defaultMessage: 'Execution Clients: {clientName}' },
        { clientName: 'Geth' }
      )}
    >
      <ValidatorClientPageStyles>
        <Hero imgSrc={gethBg} />
        <GethDetails />
        <section>
          <SectionTitle level={2} className="mb5">
            <FormattedMessage defaultMessage="Documentation" />
          </SectionTitle>
          <Link primary to="https://geth.ethereum.org/docs/">
            <FormattedMessage defaultMessage="Documentation on running Geth" />
          </Link>
        </section>
      </ValidatorClientPageStyles>
    </PageTemplate>
  );
};
